/* Editar as notas (changelog) de uma release (ADR-0659). O app exibe estas notas na tela "Versões".
   Markdown. DialogContent locked ao salvar. */
import type { Release } from '@planuze/admin-contracts';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Label,
  Textarea,
  toast,
} from '@planuze/ui';
import { useState } from 'react';
import { useReleasesAdminContent } from '../../content/sections/releases-admin.js';
import { useUpdateReleaseNotes } from '../../hooks/use-releases.js';

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly release: Release;
}

export function ReleaseNotesModal({ open, onClose, release }: Props) {
  const [notes, setNotes] = useState(release.releaseNotes ?? '');
  const update = useUpdateReleaseNotes();
  const copy = useReleasesAdminContent().notesModal;

  const onSubmit = (): void => {
    const trimmed = notes.trim();
    update.mutate(
      {
        channel: release.channel,
        version: release.version,
        releaseNotes: trimmed === '' ? null : notes,
      },
      {
        onSuccess: () => {
          toast.success(copy.savedToast);
          onClose();
        },
        onError: () => toast.error(copy.saveErrorToast),
      },
    );
  };

  return (
    <Dialog open={open} onOpenChange={(next) => !next && !update.isPending && onClose()}>
      <DialogContent locked={update.isPending} className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{copy.title(release.version)}</DialogTitle>
          <DialogDescription>{copy.description}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          <Label htmlFor="notes-md">{copy.notesLabel}</Label>
          <Textarea
            id="notes-md"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={10}
            placeholder={copy.notesPlaceholder}
          />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} disabled={update.isPending}>
            {copy.cancel}
          </Button>
          <Button onClick={onSubmit} loading={update.isPending}>
            {copy.save}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
